// extracted by mini-css-extract-plugin
export var badge = "EmailNewsletterFormLoader-module--badge--62a61";
export var fadeTextIn = "EmailNewsletterFormLoader-module--fadeTextIn--66a19";
export var fadeTextOut = "EmailNewsletterFormLoader-module--fadeTextOut--d3534";
export var loader = "EmailNewsletterFormLoader-module--loader--a937b";
export var morphingOut = "EmailNewsletterFormLoader-module--morphingOut--43d5c";
export var scaleBadgeIn = "EmailNewsletterFormLoader-module--scaleBadgeIn--30743";
export var scaleBadgeOut = "EmailNewsletterFormLoader-module--scaleBadgeOut--cf122";
export var tagline = "EmailNewsletterFormLoader-module--tagline--04deb";